import { jsx as _jsx } from "react/jsx-runtime";
import Image from "next/image";
import { useConfig } from "../Config/ConfigContext";
import { ImgixClient } from "../Imgix";
import { useCallback } from "react";
export const ImgixImage = (props)=>{
    const { imgixConfig  } = useConfig();
    const imgix = new ImgixClient(imgixConfig.s3Domain);
    const loader = useCallback((e)=>imgix.buildUrl(e.src, {
            w: e.width,
            auto: "compress"
        }), []);
    return /*#__PURE__*/ _jsx(Image, {
        loader: loader,
        ...props
    });
};
